import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn('h-5 w-5 animate-spin text-muted-foreground', className)} />
}

export function FullScreenLoader() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <Spinner className="h-8 w-8" />
    </div>
  )
}
